import React from 'react'

const IconRegularGuest = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='none' viewBox='0 0 20 20'>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='M7.667 5.833a2.333 2.333 0 1 1 4.667 0 2.333 2.333 0 0 1-4.667 0M10.001 1.5a4.333 4.333 0 1 0 0 8.667A4.333 4.333 0 0 0 10 1.5M4.334 16.667A3.167 3.167 0 0 1 7.501 13.5h1.833v-2H7.501a5.167 5.167 0 0 0-5.167 5.167v1h2z'
				clipRule='evenodd'
			/>
			<path
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.733'
				d='m17.33 13.797-.89-.927c-.641-.668-.892-1.027-1.24-.9-.432.158-.29 1.157-.29 1.495-.673 0-1.372-.062-2.036.067C10.684 13.96 10 15.83 10 17.843c.62-.456 1.239-.964 1.984-1.175.93-.264 1.968-.138 2.926-.138 0 .337-.142 1.336.29 1.495.394.144.599-.232 1.24-.9l.89-.927c.545-.57.818-.853.818-1.2 0-.348-.273-.632-.818-1.201'
			/>
		</svg>
	)
}

export default IconRegularGuest
